export default {"src":"/_next/static/media/assistant-cook-with-green-text-box.3b53a8c0.svg","height":378,"width":301};